const cards = [
  {
    tag: "Nova empresa",
    title: "Abra sua empresa nos EUA do jeito certo",
    description:
      "Nossa equipe acompanha você em cada etapa da abertura da sua empresa nos EUA. Processo totalmente em português, sem burocracia e com orientação personalizada do início ao fim.",
    cta: "Abrir minha empresa →",
    ctaSecondary: null,
    image:
      "https://public.readdy.ai/ai/img_res/ca9d0f959400c3c75dd6fc8aa2ff1651.jpg",
    features: [
      "Suporte jurídico incluído",
      "Processo 100% online",
      "Sem precisar viajar aos EUA",
    ],
  },
  {
    tag: "Atendimento personalizado",
    title: "Você não está sozinho nessa jornada",
    description:
      "Não somos mais uma empresa com respostas automáticas. Cada cliente tem um atendimento único, com especialistas que conhecem sua situação e falam a sua língua — literalmente.",
    cta: "Falar com especialista →",
    ctaSecondary: "Ver nossos planos",
    image:
      "https://readdy.ai/api/search-image?query=two%20professionals%20in%20friendly%20conversation%20across%20a%20table%20warmly%20discussing%20documents%20bilingual%20team%20smiling%20attentive%20listening%20personalized%20customer%20service%20modern%20bright%20office%20minimal%20style%20human%20connection&width=560&height=380&seq=card-personalizado-02&orientation=landscape",
    features: [
      "Endereço virtual em Miami",
      "Conta bancária nos EUA",
      "Especialistas em português",
      "Atendimento humanizado",
    ],
  },
  {
    tag: "Preços transparentes",
    title: "Sem surpresas, sem taxas escondidas",
    description:
      "Clareza total sobre o que você está pagando e pelo quê. Nossos planos foram pensados para empreendedores internacionais que querem crescer com segurança e confiança.",
    cta: "Ver todos os planos →",
    ctaSecondary: "Fale com um especialista",
    image:
      "https://readdy.ai/api/search-image?query=professional%20video%20call%20meeting%20laptop%20screen%20showing%20business%20consultation%20financial%20services%20pricing%20plan%20discussion%20modern%20home%20office%20setup%20minimal%20style%20bright%20warm%20lighting%20natural&width=560&height=380&seq=card-preco-01&orientation=landscape",
    features: [
      "Planos a partir de $19/mês",
      "Sem taxas de surpresa",
      "Cancele quando quiser",
    ],
  },
];

export default function OpenCompanySection() {
  return (
    <section id="abrir-empresa" className="bg-[#f7f7f4] py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#2563eb] text-sm font-semibold tracking-wider uppercase">Direcionado para você</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f2044] mt-2 mb-4">
            Seja para <span className="text-[#2563eb]">abrir ou expandir</span>{" "}
            sua empresa nos EUA,<br className="hidden md:block" />
            <strong className="font-extrabold">você não está sozinho</strong>
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Descubra os serviços essenciais para empreendedores que querem atuar nos Estados Unidos com tranquilidade — e sempre com alguém do seu lado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 flex flex-col"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-[#2563eb] text-xs font-semibold uppercase tracking-wider mb-3">
                  {card.tag}
                </span>
                <h3 className="text-[#0f2044] font-bold text-lg leading-tight mb-3">
                  {card.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{card.description}</p>

                <ul className="space-y-2 mb-6">
                  {card.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-gray-600">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-[#2563eb] text-sm font-bold" />
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>

                <div className="mt-auto flex flex-col gap-2">
                  <a
                    href="#contato"
                    className="bg-[#0f2044] hover:bg-[#162d5c] text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {card.cta}
                  </a>
                  {card.ctaSecondary && (
                    <a
                      href="#precos"
                      className="text-[#0f2044] hover:text-[#2563eb] text-sm font-medium text-center transition-colors cursor-pointer"
                    >
                      {card.ctaSecondary}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
